import { useEffect } from "react";
import { usePublicLanguage } from "../context/PublicLanguage";

function setMeta(attr, key, content) {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!content) { el?.remove(); return; }
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

function setJsonLd(id, data) {
  let el = document.getElementById(id);
  if (data) {
    if (!el) {
      el = document.createElement("script");
      el.type = "application/ld+json";
      el.id = id;
      document.head.appendChild(el);
    }
    el.textContent = JSON.stringify(data);
  } else if (el) {
    el.remove();
  }
}

export default function useSEO({ title, description, image, url, type = "website", lang, alternates = [], robots = "index, follow", jsonLd } = {}) {
  const { language } = usePublicLanguage();
  const displayedLanguage = lang || language;
  const serializedAlternates = JSON.stringify(alternates);
  const serializedJsonLd = JSON.stringify(jsonLd);

  useEffect(() => {
    document.documentElement.lang = displayedLanguage;
    if (title) document.title = title;
    setMeta("name", "description", description);
    setMeta("name", "robots", robots);
    setMeta("property", "og:locale", displayedLanguage === "id" ? "id_ID" : "en_US");
    setMeta("property", "og:title", title);
    setMeta("property", "og:description", description);
    setMeta("property", "og:type", type);
    setMeta("property", "og:image", image);
    setMeta("property", "og:url", url);
    setMeta("name", "twitter:card", "summary_large_image");
    setMeta("name", "twitter:title", title);
    setMeta("name", "twitter:description", description);
    setMeta("name", "twitter:image", image);

    let canonical = document.head.querySelector('link[rel="canonical"]');
    if (url) {
      if (!canonical) {
        canonical = document.createElement("link");
        canonical.rel = "canonical";
        document.head.appendChild(canonical);
      }
      canonical.setAttribute("href", url);
    }
    document.head.querySelectorAll('link[data-td-alternate]').forEach(el => el.remove());
    JSON.parse(serializedAlternates).forEach(({ lang: alternateLang, url: href }) => {
      const link = document.createElement("link"); link.rel = "alternate"; link.hreflang = alternateLang;
      link.href = href; link.dataset.tdAlternate = "true"; document.head.appendChild(link);
    });
    if (!url && canonical) canonical.remove();
    setJsonLd("td-jsonld", serializedJsonLd ? JSON.parse(serializedJsonLd) : undefined);
    return () => { setJsonLd("td-jsonld", null); document.head.querySelectorAll("link[data-td-alternate]").forEach(el => el.remove()); };
  }, [title, description, image, url, type, serializedJsonLd, serializedAlternates, displayedLanguage, robots]);
}
